import { render, staticRenderFns } from "./typeTips.vue?vue&type=template&id=4d74429a&scoped=true"
import script from "./typeTips.vue?vue&type=script&lang=js"
export * from "./typeTips.vue?vue&type=script&lang=js"
import style0 from "./typeTips.vue?vue&type=style&index=0&id=4d74429a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d74429a",
  null
  
)

export default component.exports